import { IonButton, IonContent } from "@ionic/react";
interface Props {
  setShowPaperErrorModal: Function;
}
const PaperErrorPopup: React.FC<Props> = ({ setShowPaperErrorModal }) => {
  return (
    <IonContent className="light-error-wrap-content" placeholder={undefined}>
      <div className="light-error-wrap">
        <div className="top-sec">
          <svg
            width="147"
            height="147"
            viewBox="0 0 147 147"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M73.5 139C109.675 139 139 109.675 139 73.5C139 37.3253 109.675 8 73.5 8C37.3253 8 8 37.3253 8 73.5C8 109.675 37.3253 139 73.5 139Z"
              stroke="white"
              strokeWidth="14.5556"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M73.1376 98.6098H73.8654V99.3375H73.1376V98.6098Z"
              stroke="white"
              strokeWidth="14.5556"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M73.5 47.6653V76.7764"
              stroke="white"
              strokeWidth="14.5556"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <h1>PAPER ERROR</h1>
        </div>
        <div className="bottom-sec">
          <h4>Position the paper
VERTICALLY and as
straight as possible.</h4>
          <IonButton
            className="generic-btn"
            onClick={() => setShowPaperErrorModal(false)} placeholder={undefined}          >
            Retry
          </IonButton>
        </div>
      </div>
    </IonContent>
  );
};
export default PaperErrorPopup;
